export const STANDALONE_ROUTE = /^\/(reports\/active-buyer\/|r\/|(brokerage|agent-info)\/[^/]+\/buyers(\/|$))/;
